import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Box, Label } from 'fw/components'
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as App from 'modules/app/App';
import * as Modals from 'fw/globals/Modals';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSuitcase, faAngleDoubleRight, faUsers, faBuilding } from '@fortawesome/free-solid-svg-icons'
import CertificationCard from './CertificationCard';

class CertificationDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			companyFein: null,
			companyFeinKey: null,
			companyKey: null,
			companyNameKey: null,
			certificationExists: null,
			certificationKey: null,
			certificationStepCode: null,
			inProgressCertifications: [],
			preQualifyCertifications: [],
			payedPreQualifyCertifications: [],
			finishedCertifications: [],
			approvedCertifications: [],
			deniedCertifications: [],
		};
	}

	componentDidMount() {
		if (App.context().passwordExpirationRemainingDays !== 0) {
			Modals.confirm("Your password will expire in " + App.context().passwordExpirationRemainingDays + " days. Would you like to change your password now?", () => {
				this.props.history.push('/accounts/profile#SecurityTab');
			});
		}

		App.updatePasswordExpirationRemainingDays(0);

		if (App.hasPrivilege("CertificationDashboardAccess"))
			this.getCertification();
	}

	getCertification = () => {
		API.Biz.get('/dashboard/getUserCertification', {},
			{
				success: (r) => {
					if (r.data !== null) {
						this.setState(
							{
								certificationKey: r.data.certificationKey,
								certificationStepCode: r.data.certificationStepCode,
								finishedCertifications: r.data.finishedCertifications,
								inProgressCertifications: r.data.inProgressCertifications,
								preQualifyCertifications: r.data.preQualifyCertifications,
								payedPreQualifyCertifications: r.data.payedPreQualifyCertifications,
								approvedCertifications: r.data.approvedCertifications,
								deniedCertifications: r.data.deniedCertifications,
								fullName: r.data.fullName,
								certificationExists: r.data.certificationExists,
								companyKey: r.data.companyKey,
								companyNameKey: r.data.companyNameKey,
								companyFein: r.data.companyFein,
								companyFeinKey: r.data.companyFeinKey
							});
					}
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

	renderConnectToVOBPanel = (disabled) => {
		if (disabled)
			return (
				<div className="panel panel-default">
					<div className="panel-body" style={{ padding: '5px'}}>
						<p><strong><p style={{color:"#C6C3C3"}}>CONNECT</p></strong></p>
						<FontAwesomeIcon icon={faUsers} size="3x" color="#C6C3C3" className="my-icon" />
						<br />
						<p>NVBDC Events. Connect to VOB/SDVOB’s.</p>
					</div>
				</div>);

		return (
			<a href="/connectToVOB">
				<div className="panel panel-default dashboard-hover-box">
					<div className="panel-body" style={{ padding: '5px'}}>
						<p><strong>CONNECT</strong></p>
						<FontAwesomeIcon icon={faUsers} size="3x" color="#00A65A" className="my-icon" />
						<br />
						<p>NVBDC Events. Connect to VOB/SDVOB’s.</p>
					</div>
				</div>
			</a>);
	}

	renderConnectToSponsorsPanel = (disabled) => {
		if (disabled)
			return (
				<div className="panel panel-default">
					<div className="panel-body" style={{ padding: '5px'}}>
						<div>
							<p><strong><p style={{color:"#C6C3C3"}}>CORPORATE MEMBERS</p></strong></p>
							<FontAwesomeIcon icon={faSuitcase} size="3x" color="#C6C3C3" className="my-icon" />
						</div>
						<br />
						<p>Find NVBDC Members. Connect to Resources.</p>
					</div>
				</div>
			);
		
		return (
			<a href="/connectToSponsors">
				<div className="panel panel-default dashboard-hover-box">
					<div className="panel-body" style={{ padding: '5px'}}>
						<div>
							<p><strong>CORPORATE MEMBERS</strong></p>
							<FontAwesomeIcon icon={faSuitcase} size="3x" color="#F39C12" className="my-icon" />
							<br />
						</div>
						<br />
						<p>Find NVBDC Members. Connect to Resources.</p>
					</div>
				</div>
			</a>);
	}

	render() {
		const restrictedAccessTooltip = (
            <Tooltip id="restrictedAccessTooltip">
                <Row>
                    <Col md={12}>
						Access restricted
                    </Col>
                </Row>
            </Tooltip>
        );

		return (
			App.hasPrivilege("CertificationDashboardAccess") ?
				<React.Fragment>
					{this.state.fullName !== undefined ?
						<ContentHeader title={"Home - " + this.state.fullName}>
						</ContentHeader> : null
					}
					<ContentBody>
						<div className="panel panel-default">
							<div className="panel-body dashboard">
								<Row>
									<Col md={12}>
										<Row>
											<Col md={App.context().showMenu ? 10 : 12}>
												<Row>
													<Col md={12}>
														<p>
															It is the Veterans responsibility to notify VOCS of any Owner changes.<br />
															<small>Please report any changes to <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a>. Please ensure that you include your Certification ID.</small>
														</p>
													</Col>
												</Row>
												<Row>
													{ (this.state.inProgressCertifications && this.state.inProgressCertifications.length > 0) ||
													  (this.state.preQualifyCertifications && this.state.preQualifyCertifications.length > 0) ||
													  (this.state.payedPreQualifyCertifications && this.state.payedPreQualifyCertifications.length > 0) ||
													  (this.state.finishedCertifications && this.state.finishedCertifications.length > 0) ?
														<Col md={12}>
															<Box boxStyle="info">
																<Row>
																	<Col md={12}>
																		<Label style={{fontSize:"18px"}}>
																			<FontAwesomeIcon icon={faAngleDoubleRight} size="1x" color="#00C0EF" className="my-icon" />
																			&nbsp;&nbsp;In Progress Applications
																		</Label>
																		<br />
																		<hr />
																	</Col>
																</Row>
																<Row>
																	{this.state.preQualifyCertifications.map((certification) => {
																		return (
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					stepCode={certification.stepCode}
																					certificationStatus="prequalification"
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					vobKey={certification.vobKey}
																					preQualificationCreateDate={certification.preQualificationCreateDate}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft} />
																			</Col>);
																			}
																	)}
																	{this.state.inProgressCertifications.map((certification) => {
																		return (
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					stepCode={certification.stepCode}
																					certificationStatus="inProgress"
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft}
																					isRenewal={certification.isRenewal} />
																			</Col>);
																			}
																	)}
																	{this.state.payedPreQualifyCertifications.map((certification) => {
																		return (
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					certificationStatus="payed"
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					vobKey={certification.vobKey}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft} />
																			</Col>);
																		}
																	)}
																	{this.state.finishedCertifications.map((certification) => {
																		return (
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					certificationStatus="finished"
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft} />
																			</Col>);
																		}
																	)}
																</Row>
															</Box>
														</Col>
													: null }
													{ (this.state.approvedCertifications && this.state.approvedCertifications.length > 0) ||
													  (this.state.deniedCertifications && this.state.deniedCertifications.length > 0) ?
														<Col md={12}>
															<Box boxStyle="success">   
																<Row>
																	<Col md={12}>
																		<Label style={{fontSize:"18px"}}>
																			<FontAwesomeIcon icon={faAngleDoubleRight} size="1x" color="#00A65A" className="my-icon" />
																			&nbsp;&nbsp;Completed Applications
																		</Label>
																		<br />
																		<hr />
																	</Col>
																</Row>
																<Row>
																	{this.state.approvedCertifications.map((certification) => {
																		if (certification.expirationDays < 0 || certification.recertificationAvailable || certification.renewalAvailable)
																			return null;

																		return(
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					certificationStatus="approved"
																					expirationDays={certification.expirationDays}
																					expirationDate={certification.expirationDate}
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft} />
																			</Col>);
																		}
																	)}
																	{this.state.deniedCertifications.map((certification) => {
																		return(
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					certificationStatus="denied"
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					vobFeinKey={certification.vobFeinKey}
																					submitDate={certification.submitDate}
																					appealAvailable={certification.appealAvailable}
																					appealInProgress={certification.appealInProgress} />
																			</Col>);
																		}
																	)}
																	{this.state.approvedCertifications.map((certification) => {
																		if (certification.expirationDays >= 0 && !certification.recertificationAvailable && !certification.renewalAvailable)
																			return null;

																		return(
																			<Col md={3}>
																				<CertificationCard 
																					key={certification.certificationKey}
																					certificationKey={certification.certificationKey}
																					certificationId={certification.certificationId}
																					certificationStatus={(certification.recertificationAvailable || certification.renewalAvailable) ? "expiring" : "expired"}
																					expirationDays={certification.expirationDays}
																					expirationDate={certification.expirationDate}
																					recertificationAvailable={certification.recertificationAvailable}
																					renewalAvailable={certification.renewalAvailable}
																					vobName={certification.vobName}
																					vobFein={certification.vobFein}
																					vobFeinKey={certification.vobFeinKey}
																					submitDate={certification.submitDate}
																					daysInDraft={certification.daysInDraft} />
																			</Col>);
																		}
																	)}
																</Row>
															</Box>
														</Col>
													: null }
												</Row>
											</Col>
											{ App.context().showMenu ?
												<Col style={{borderLeft: "1px solid #eee"}} md={2}>
													<Row>
														<Col lg={12} md={12} className="text-center">
															<a href="/certification/addPreQualification">
																<div className="panel panel-default dashboard-hover-box">
																	<div className="panel-body" style={{ padding: '5px'}}>
																		<p>
																			<strong>
																				<FontAwesomeIcon icon={faPlus} size="1x" color="#00a65a" className="my-icon" />
																				&nbsp;&nbsp; New Application
																			</strong>
																		</p>
																		<small>Add New Business</small>
																	</div>
																</div>
															</a>
														</Col>
														<Col lg={12} md={12} className="text-center">
															<a href="/manageCompany">
																<div className="panel panel-default dashboard-hover-box">
																	<div className="panel-body" style={{ padding: '5px'}}>
																		<p><strong>COMPANY</strong></p>
																		<FontAwesomeIcon icon={faBuilding} size="3x" color="#DD4B39" className="my-icon" />
																		<br />
																		<br />
																		<p style={{ height: 55, fontSize: '13px' }}>Update Profile, Capabilities or Accreditation Statement(s). Manage User Access.</p>
																	</div>
																</div>
															</a>
														</Col>
														<Col lg={12} md={12} className="text-center">
															{ App.hasPrivilege("ConnectToVOBAccess") ?
																this.renderConnectToVOBPanel(false)
															:
																<OverlayTrigger placement="top" overlay={restrictedAccessTooltip}>
																	{this.renderConnectToVOBPanel(true)}
																</OverlayTrigger>
															}
														</Col>
														<Col lg={12} md={12} className="text-center">
															{ App.hasPrivilege("ConnectToSponsorsAccess") ?
																this.renderConnectToSponsorsPanel(false)
															:
																<OverlayTrigger placement="top" overlay={restrictedAccessTooltip}>
																	{this.renderConnectToSponsorsPanel(true)}
																</OverlayTrigger>
															}
														</Col>
													</Row>
												</Col>
											: null }
										</Row>
									</Col>
								</Row>
							</div>
						</div>
					</ContentBody>
				</React.Fragment >
			: null
		)
	}
}

export default CertificationDashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/certificationDashboard/CertificationDashboard.js